<script>
import Layout from "@/router/layouts/main";
import { mapState } from "vuex";
import { api } from "@/state/services";

export default {
  locales: {
    pt: {
    },
    es: {
    }
  },
  components: {
    Layout,
  },
  computed: {
    ...mapState({
      account: state => state.account
    }),
  },
  data() {
    return {
      payments: null,

      show: {
        modal: false,

        id: null,
        status: null,
        date: null,
        plan: null,
        value: null,
        methods: null,
      }
    };
  },
  methods: {
    getPayments() {
      this.list = null;

      api
        .get('payments')
        .then((response) => {
          if (response.data.status == 'success') {
            this.payments = response.data.list;
          }
        })
    },
    showPayment(id) {
      this.show.modal = false;
      this.show.modal = true;

      api
        .get('payments/' + id)
        .then((response) => {
          if (response.data.status == 'success') {
            this.show.id      = response.data.payment.id;
            this.show.status  = response.data.payment.status;
            this.show.date    = response.data.payment.date;
            this.show.plan    = response.data.payment.plan;
            this.show.value   = response.data.payment.value;
            this.show.methods = response.data.payment.methods;
          }
        })
    },
  },
  mounted() {
    this.getPayments();
  }
};
</script>

<template>
  <Layout>
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <router-link tag="a" to="/">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
            <path d="M5 22h14a2 2 0 0 0 2-2v-9a1 1 0 0 0-.29-.71l-8-8a1 1 0 0 0-1.41 0l-8 8A1 1 0 0 0 3 11v9a2 2 0 0 0 2 2zm5-2v-5h4v5zm-5-8.59 7-7 7 7V20h-3v-5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v5H5z">
            </path>
          </svg>
        </router-link>
      </li>
      <li class="breadcrumb-item">Pagamentos</li>
    </ol>

    <div class="page-title-box d-md-flex justify-content-between mb-3">
      <div>
        <h3>Minhas Faturas</h3>
        <p>Gerencie suas faturas.</p>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <div class="min-vh-25 text-center d-flex justify-content-center align-items-center" v-if="!payments">
          <b-spinner variant="default" role="status"></b-spinner>
        </div>

        <div v-else-if="payments && payments.length == 0" class="min-vh-25 text-center d-flex justify-content-center align-items-center">
          <div>
            <i class="far fa-sad-cry font-size-24"></i><br>
            nenhuma fatura encontrada.
          </div>
        </div>

        <div v-else class="table-responsive">
          <table class="table table-centered table-nowrap">
            <thead class="thead-light">
              <tr>
                <th>#</th>
                <th>Data</th>
                <th>Plano</th>
                <th>Valor</th>
                <th>Status</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in payments" :key="row.index">
                <td>{{ row.id.split('-')[0] }}</td>
                <td>{{ row.date }}</td>
                <td>{{ row.plan }}</td>
                <td>{{ row.value | currency }}</td>
                <td>
                  <span class="badge badge-soft-danger font-size-13" v-if="row.status == 'pending'">PENDENTE</span>
                  <span class="badge badge-soft-warning font-size-13" v-else-if="row.status == 'processing'">PROCESSANDO</span>
                  <span class="badge badge-soft-success font-size-13" v-else-if="row.status == 'approved'">APROVADO</span>
                  <span class="badge badge-soft-danger font-size-13" v-else-if="row.status == 'repproved'">REPROVADO</span>
                </td>
                <td class="text-right">
                  <button v-on:click="showPayment(row.id)" class="btn btn-default btn-sm btn-rounded">
                    Ver
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <b-modal v-model="show.modal" modal-class="modal-right" title="Fatura" hide-footer>
      <div v-if="show && !show.id" class="text-center d-flex justify-content-center align-items-center">
        <b-spinner variant="default" role="status"></b-spinner>
      </div>
      <div v-else>
        <div class="mb-5">
          <div class="mb-3">
            <span v-if="show.status == 'pending'" class="badge badge-soft-danger p-1 px-2 font-size-13 text-uppercase">PENDENTE</span>
            <span v-else-if="show.status == 'processing'" class="badge badge-soft-warning p-1 px-2 font-size-13 text-uppercase">PROCESSANDO</span>
            <span v-else-if="show.status == 'approved'" class="badge badge-soft-success p-1 px-2 font-size-13 text-uppercase">APROVADO</span>
            <span v-else-if="show.status == 'repproved'" class="badge badge-soft-danger p-1 px-2 font-size-13 text-uppercase">REPROVADO</span>
          </div>
          <h3 class="mb-0">{{ show.value | currency }}</h3>
          <div class="text-uppercase">
            Vencimento {{ show.date }}
          </div>
        </div>

        <b-tabs v-if="show.status === 'pending'" justified nav-class="nav-tabs-custom mt-3" content-class="py-3 text-muted">
          <b-tab v-for="(pay, method) in show.methods" :key="method">
            <template v-slot:title>{{ pay.name }}</template>
            <div v-if="method == 'pix'" class="py-3 text-center">
              <div v-if="pay.pix && pay.pix.text">
                <div v-if="pay.pix.image">
                  <div>
                    Use o código QR para prosseguir com a transação.
                  </div>
                  <div class="my-4 d-flex justify-content-center">
                    <div class="border rounded p-3">
                      <img style="width: 180px" :src="'data:image/png;base64,' + pay.pix.image" />
                    </div>
                  </div>
                  <div>
                    Ou utilize o Pix Copia e Cola para prosseguir com a transação.
                  </div>
                </div>
                <div v-else>
                  Use o Pix Copia e Cola para prosseguir com a transação.
                </div>
                <div class="my-4">
                  <fieldset class="text-break py-3">{{ pay.pix.text }}</fieldset>
                </div>
                <div>
                  <button class="btn btn-default btn-lg btn-block text-uppercase" v-clipboard:copy="pay.pix.text"
                    v-on:click="$toast.success('<strong>Copiado para a área de transferência.</strong><br>Agora, tudo o que você precisa fazer é acessar o aplicativo do seu banco e concluir o processo usando o <strong>Pix Copia e Cola</strong>.')">
                    Copiar Pix Copia e Cola
                  </button>
                </div>
              </div>
            </div>
          </b-tab>
        </b-tabs>
      </div>
    </b-modal>
  </Layout>
</template>